
<section class="home-estimate-banner" [ngStyle]="showBannerStyle">
  <div class="wrapper" >
    <div class="inner-content">
      <h1 class="title" translate="home-estimator.title" ></h1>
      <h2 class="subtitle" translate="home-estimator.subtitle" ></h2>
      <div class="search-bar-wrapper">
        <app-home-estimator-search-bar #appSearchBar
            [rightPositionedIcon]="true"
            [placeholder]="searchBarPlaceholder"
            [updatePlaceholder]="false"
        ></app-home-estimator-search-bar>
      </div>
    </div>
    <h2 class="powered-by" translate="home-estimator.powered-by"></h2>
    <img src="{{'/assets/home-estimator/teranet-logo-home.svg' | staticp}}" height="25px" width="151.6px"/>
  </div>
  <app-request-sent *ngIf="showRequestSent" (onClose)="showRequestSent = false" ></app-request-sent>
</section>
<section class="second-section">
  <app-home-estimator-lead-form [showRequestSent]="showRequestSent" (showRequestSentEvent)="showRequestSent=true">
  </app-home-estimator-lead-form>
</section>
<section class="teranet-section">
  <div class="teranet-container is-flex-column">
    <div class="teranet-headline">
      <p class="headline" translate="home-estimator.teranet.in-partnership-with"></p>
      <img class="teranet-logo" src="{{'/assets/teranet/Teranet-logo.svg' | staticp}}" alt="Teranet logo"/>
    </div>
    <div class="teranet-points is-flex">
      <a class="teranet-point is-flex-column" target="_blank" rel="nofollow" href="{{teranetAboutUsLink}}">
        <img src="{{'/assets/teranet/about_us.png' | staticp}}" alt="Teranet About Us"/>
        <strong class="headline" translate="home-estimator.teranet.about-teranet"></strong>
        <p class="explaination" translate="home-estimator.teranet.learn-more-about-us"></p>
      </a>
      <a class="teranet-point is-flex-column" target="_blank" rel="nofollow" href="{{teranetOurDataLink}}">
        <img src="{{'/assets/teranet/our_data.png' | staticp}}" alt="Teranet Our Data"/>
        <strong class="headline"  translate="home-estimator.teranet.our-data"></strong>
        <p class="explaination" translate="home-estimator.teranet.foundation"></p>
      </a>
      <a class="teranet-point is-flex-column" target="_blank" rel="nofollow" href="{{teranetSolutionsLink}}">
        <img src="{{'/assets/teranet/solutions.png' | staticp}}" alt="Teranet Solutions"/>
        <strong class="headline" translate="home-estimator.teranet.solutions"></strong>
        <p class="explaination" translate="home-estimator.teranet.professionals"></p>
      </a>
    </div>
  </div>
  </section>
